// extracted by mini-css-extract-plugin
export default {"floatingBanner":"tWxSLd","chat":"a1QwpP","fullPage":"W67VTU","home":"PtdH9_","hasFooter":"SP9pFD"};